<ion-content class="login-success-content">
  <div class="login-success-container">
    <div class="success-card">
      <!-- Hand holding smartphone illustration -->
      <div class="hand-illustration">
        <img src="https://img.travelx.ai/bfl/login_successful.png" alt="Login Success" class="hand-image">
      </div>
      
      <!-- Success message -->
      <div class="success-message">
        <h2 class="success-title">Login Successful</h2>
      </div>
      
      <!-- Continue booking button -->
      <div class="action-section">
        <button class="continue-btn" (click)="onContinueBooking()">
          <span class="btn-text">View My Booking</span>
          <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
        </button>
      </div>
    </div>
  </div>
</ion-content>
